import { Link } from 'react-router-dom'
import { 
  Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin,
  Banknote, Truck, RotateCcw, Shield, CreditCard, Smartphone, Wallet
} from 'lucide-react'
import { Input } from '../ui/input'
import { Button } from '../ui/button'

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border mt-12">
      {/* Newsletter Section */}
      <div className="bg-muted/50 py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-xl font-bold text-foreground mb-2">
              Subscribe to BotTola for exclusive offers!
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              Get the latest deals and updates directly to your inbox
            </p>
            <div className="flex gap-2 max-w-md mx-auto">
              <Input
                type="email"
                placeholder="Enter your email"
                className="flex-1"
              />
              <Button variant="primary">Subscribe</Button>
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              We respect your privacy
            </p>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="border-y border-border py-6">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="flex flex-col items-center gap-2">
              <Banknote className="h-8 w-8 text-primary" />
              <div className="text-sm font-medium">Cash on Delivery</div>
              <div className="text-xs text-muted-foreground">Pay at your doorstep</div>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Truck className="h-8 w-8 text-primary" />
              <div className="text-sm font-medium">Nationwide Delivery</div>
              <div className="text-xs text-muted-foreground">All over Bangladesh</div>
            </div>
            <div className="flex flex-col items-center gap-2">
              <RotateCcw className="h-8 w-8 text-primary" />
              <div className="text-sm font-medium">Easy Returns</div>
              <div className="text-xs text-muted-foreground">7-day return policy</div>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Shield className="h-8 w-8 text-primary" />
              <div className="text-sm font-medium">Secure Payments</div>
              <div className="text-xs text-muted-foreground">SSL encrypted</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Us */}
          <div>
            <h4 className="font-bold text-foreground mb-4">About Us</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary">About BotTola</Link></li>
              <li><Link to="/careers" className="hover:text-primary">Careers</Link></li>
              <li><Link to="/press" className="hover:text-primary">Press</Link></li>
              <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/contact" className="hover:text-primary">Contact Us</Link></li>
              <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
              <li><Link to="/track" className="hover:text-primary">Track Order</Link></li>
              <li><Link to="/returns" className="hover:text-primary">Return Policy</Link></li>
              <li><Link to="/shipping" className="hover:text-primary">Shipping Info</Link></li>
            </ul>
          </div>

          {/* Sell on BotTola */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Sell on BotTola</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/sell" className="hover:text-primary">Become a Seller</Link></li>
              <li><Link to="/seller-login" className="hover:text-primary">Seller Login</Link></li>
              <li><Link to="/seller-guidelines" className="hover:text-primary">Guidelines</Link></li>
              <li><Link to="/seller-support" className="hover:text-primary">Seller Support</Link></li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-0.5" />
                <div>
                  <div>16XXX</div>
                  <div className="text-xs">(9 AM - 8 PM, Sat-Thu)</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5" />
                <div>support@bottola.com</div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5" />
                <div>Dhaka-1000, Bangladesh</div>
              </li>
            </ul>
            
            <div className="flex gap-2 mt-4">
              <a href="/" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="/" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="/" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="/" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-border py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-muted-foreground">
              © 2026 BotTola.com. All rights reserved.
            </div>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <Link to="/terms" className="hover:text-primary">Terms & Conditions</Link>
              <Link to="/privacy" className="hover:text-primary">Privacy Policy</Link>
            </div>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4 mt-4">
            <span className="text-xs text-muted-foreground">Payment Methods:</span>
            
            {/* Mobile Payment */}
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <Smartphone className="h-4 w-4 text-pink-500" />
              <span className="text-xs font-semibold">bKash</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <Wallet className="h-4 w-4 text-orange-500" />
              <span className="text-xs font-semibold">Nagad</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <Wallet className="h-4 w-4 text-purple-500" />
              <span className="text-xs font-semibold">Rocket</span>
            </div>
            
            {/* Cards */}
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <CreditCard className="h-4 w-4 text-blue-600" />
              <span className="text-xs font-semibold">Visa</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <CreditCard className="h-4 w-4 text-red-600" />
              <span className="text-xs font-semibold">Mastercard</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <CreditCard className="h-4 w-4 text-blue-500" />
              <span className="text-xs font-semibold">Amex</span>
            </div>
            
            {/* Digital Wallets */}
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <CreditCard className="h-4 w-4 text-blue-700" />
              <span className="text-xs font-semibold">PayPal</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <Smartphone className="h-4 w-4" />
              <span className="text-xs font-semibold">Apple Pay</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <Wallet className="h-4 w-4 text-green-600" />
              <span className="text-xs font-semibold">Google Pay</span>
            </div>
            
            <div className="flex items-center gap-1 px-3 py-1.5 rounded border border-border bg-muted/50">
              <CreditCard className="h-4 w-4 text-purple-600" />
              <span className="text-xs font-semibold">Stripe</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
